import styled from 'styled-components'

export const TableContainer = styled.div`
    display: flex;
    width: 100%;
`

export const TableWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: left;
    width: 100%;
`
